import { useSnackbarStack } from '@superdispatch/ui';
import { useNavigate } from 'react-router-dom';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { useQuery } from 'shared/helpers/RoutingHelpers';
import { SuperPayRequestShipperContent } from 'shared/modules/superpay/SuperPayRequestShipperContent';
import { SuperPayWebviewHeader } from './SuperPayWebviewHeader';

export function RequestShipperWebViewPage() {
  const { addSnackbar } = useSnackbarStack();
  const navigate = useNavigate();
  const [{ utm_medium = '', back_url }] = useQuery();

  return (
    <SuperPayWebviewHeader>
      <SuperPayRequestShipperContent
        onClose={() => {
          if (back_url) {
            navigate(back_url, { replace: true });
          } else {
            MobileAppBridge.closeScreen();
          }
        }}
        onSubmitSuccess={(message) => {
          if (back_url) {
            addSnackbar(message, { variant: 'success' });
          } else {
            MobileAppBridge.sentSuperPayRequestShipper();
          }
        }}
        source={utm_medium}
        isWebView={true}
      />
    </SuperPayWebviewHeader>
  );
}
